// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"2656d6f4","802":"b68d54fd","842":"4e508e1e","960":"98fccf09"}[chunkId] + ".chunk.js";
};